import cx from 'classnames'
import { groupBy } from 'lodash'
import React, { ReactNode, useEffect } from 'react'

import { InlineFormatHeader } from './components/InlineFormatHeader/InlineFormatHeader'

import Styles from './InlineFormatBar.module.scss'
import { InlineFormatFooter } from 'components/InlineFormatBar/components/InlineFormatFooter/InlineFormatFooter'

interface Props {
  children: ReactNode
  className?: string
  contentClassName?: string
  close?: () => void
  uuid?: string
}

interface Groups {
  header?: Array<React.ReactElement<{}>>
  footer?: Array<React.ReactElement<{}>>
  content?: ReactNode[]
}

class FormatBarStack {
  subscribers: Array<() => void> = []
  subscribe(fn: () => void) {
    // unsubscribe previous, keeping only one visible
    while (this.subscribers.length > 0) this.subscribers.pop()?.()
    this.subscribers.push(fn)
    return () => {
      fn()
      this.subscribers = this.subscribers.filter((s) => s !== fn)
    }
  }
}

const THE_FORMAT_BAR_STACK = new FormatBarStack()

export const InlineFormatBar = ({ children, className, contentClassName, close }: Props) => {
  const childrenArray = React.Children.toArray(children)
  const classifier = (node: (typeof childrenArray)[0]) => {
    if (React.isValidElement(node) && node.type === InlineFormatHeader) {
      return 'header'
    }
    if (React.isValidElement(node) && node.type === InlineFormatFooter) {
      return 'footer'
    }
    return 'content'
  }
  const groups = groupBy(childrenArray, classifier) as Groups

  useEffect(() => THE_FORMAT_BAR_STACK.subscribe(() => close?.()), []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={cx(Styles.container, className)}>
      {groups.header && <div className={Styles.headerContainer}>{groups.header}</div>}
      <div className={cx(Styles.contentContainer, contentClassName)}>{groups.content}</div>
      {groups.footer && <div className={Styles.footerContainer}>{groups.footer}</div>}
    </div>
  )
}
